import React, { useState,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";

import { AddOptionToString,LoginAfterCheckLogin,ChangeDateStringOnlyDate,ChangeMobileFormat } from "../../components/common/Common";

import "../../css/style.css";

//학부모계정
const ParentSet = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const navigate = useNavigate();
  
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varTotalCount,setTotalCount] = useState(0);
  const [varParentsList,setParentsList] = useState([]);
  const [varSearchName,setSearchName] = useState("");

  //학부모계정 가져오기
  const GetParentList = async() => {
    const sendData = {branch_idx:branch_idx,searchName:varSearchName};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_parents_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        let parents = datas.results;
        setTotalCount(parents.length);
        const childrens = datas.childrens;
        //학부모와 원생 매칭
        for(var i=0; i<parents.length; i++){
          let mem_idx = parents[i].mem_idx;
          let childrenList = childrens.filter(el=>el.mem_idx===mem_idx);
          let snames = "";
          for(var j=0; j < childrenList.length; j++) {
            snames = AddOptionToString(childrenList[j].ch_name,snames,',');
          }
          parents[i].childrens = snames;
        }
        //학부모 목록 저장 배열
        setParentsList(parents);
      } else {
        setTotalCount(0);
        setParentsList([]);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetParentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //검색명
  const onChangeSearchNameHandler = (e) => {
    const sname = e.currentTarget.value;
    setSearchName(sname);
  }
  //검색시작
  const onSearchHandler = (e) => {
    e.preventDefault();
    if(varSearchName === "") {
      alert('검색할 원생명이나 학부모명을 먼저 입력하세요.'); return false;
    }
    GetParentList();
  }

  //학부모/원생 정보 
  const onParentInfoHandler = (e,mem_idx) => {
    localStorage.setItem('backPageUrl','/Branch/ParentSet');
    console.log(mem_idx);
    navigate(`/Branch/ParentDetail/${mem_idx}`);
  }

  //목록 변경
  const onChangeParentChildrenHandler = (e) => {
    navigate('/Branch/ChildrenSet');
  }

  return (
    <div className="vh-content parent-search-wrap">
      <HeaderBranchTitle varPageTitle={'학부모/원생 관리'} varBackString={'none'}/>
      <div className="vh-content-body">
        {/* 학부모/원생 목록 */}
        <div className="parent-children-tab-wrap" style={{marginTop:"30px"}}>
          <ul>
            <li className="active"><div>학부모</div></li>
            <li onClick={e=>onChangeParentChildrenHandler(e)}><div>원생</div></li>
          </ul>
        </div>
        <div className="pr-search-form">
          <div className="center-wrap">
            <div className="search-wrap">
							<input type="text" name="search_name" className="search-input" placeholder="원생명, 학부모명으로 검색" value={varSearchName} onChange={e=>onChangeSearchNameHandler(e)}/>
							<button type="button" onClick={e=>onSearchHandler(e)}>검색</button>
						</div>
            <div className="search-ok-con">
              <div className="top-line2">
								<p>총 {varTotalCount}명</p>
								<Link to={"/Branch/ParentDetail/0"}>학부모/원생등록</Link>
							</div>
              {varParentsList.length===0?
                <div className="con-bg">검색된 학부모/원생정보가 없습니다.</div>
              :
                varParentsList.map((parents,i)=>(
                  <div className="con-box" key={'parents_'+i} onClick={e=>onParentInfoHandler(e,parents.mem_idx)}>
                    <div className="txt-box">
                      <div className="flex">
                        <p>등록일</p><div>{ChangeDateStringOnlyDate(parents.mem_rdate)}</div>
                      </div>
                      <div className="flex">
                        <p>학부모 코드</p><div>{parents.mem_code}</div>
                      </div>
                      <div className="flex">
                        <p>학부모명</p><div>{parents.mem_name}</div>
                      </div>
                      <div className="flex">
                        <p>학부모 계정</p><div>{parents.mem_id}</div>
                      </div>
                      <div className="flex">
                        <p>휴대폰번호</p><div>{ChangeMobileFormat(parents.mem_mobile)}</div>
                      </div>
                      <div className="flex">
                        <p>원생명</p><div>{parents.childrens}</div>
                      </div>
                    </div>
                  </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default ParentSet;